module.exports = __webpack_public_path__ + "static/media/ic-arrow-prev.8b17d295.svg";